import { gql } from '@apollo/client';

/**
 * AgentV chat file attachments. The chat mounts on both the admin dashboard and
 * the backup-servicing customer portals, and this shared `.gql.tsx` document
 * generates hooks for both the core and admin schemas (see `gql-codegen.js`).
 *
 * Upload/download are ordinary GraphQL calls, NOT part of the SSE turn stream —
 * a file is uploaded to the caller's own `agentv-attachments/<org>/<user>/`
 * prefix (derived server-side from ctx), and the agent sees it via `list_files`.
 * See `docs/AgentV_Graph_Authoring.md` §7a.
 */

// Presigned POST for uploading a file into the caller's attachment prefix.
// `serializedParams` is `{ filename }`; the server derives the key/prefix.
export const GET_AGENTV_ATTACHMENT_UPLOAD_SIGNED_URL = gql`
  query getAgentVAttachmentUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "agentVAttachment"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

// Signed GET for downloading a previously-uploaded attachment. `serializedParams`
// is `{ key }` — the exact S3 key returned by the upload; the server asserts the
// key lives under the caller's own ctx-derived prefix before signing.
export const GET_AGENTV_ATTACHMENT_DOWNLOAD_SIGNED_URL = gql`
  query getAgentVAttachmentDownloadSignedUrl($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "agentVAttachment"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

// The caller's existing attachments (filename + exact S3 key), listed from their
// own ctx-derived prefix. Lets a fresh chat rehydrate downloadable chips for
// files uploaded in a prior session (within the S3 TTL window).
export const LIST_AGENTV_ATTACHMENTS = gql`
  query listAgentVAttachments {
    listAgentVAttachments {
      filename
      key
    }
  }
`;
